import React from 'react'
import ExpensesExpenseReports from 'src/app/ExpensesExpenseReports/ExpensesExpenseReports'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { expensesExpenseReportsRouteProps } from 'src/navigation/routeProps'

const ExpensesExpenseReportsAppRoute: AppRoute = {
  id: AppLocation.AccountingExpenseReports,
  routeProps: expensesExpenseReportsRouteProps,
  component: <ExpensesExpenseReports />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default ExpensesExpenseReportsAppRoute
